module.exports = __webpack_public_path__ + "img/bg2.4374fb64.png";